import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=b46803e4&"
import script from "./OnboardingLayout.vue?vue&type=script&lang=js&"
export * from "./OnboardingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports